/* eslint-disable import/no-anonymous-default-export */
const MAX_EXPORT_RESULTS = 20000;

export default { MAX_EXPORT_RESULTS };
